module.exports = "<mat-toolbar class=\"header\">\n  <span class=\"spacer\"></span>\n  Imprint\n  <span class=\"spacer\"></span>\n</mat-toolbar>\n"